import {useCallback, useRef} from "react";
import {id} from "presentation/common/helpers/utils";
import {toastHelper} from "presentation/common/helpers/toast";
import {useFormikContext} from "formik";

export const useUploadDocuments = () => {
  const {values, setFieldValue} = useFormikContext();
  const inputRef = useRef();

  const onUploadFiles = useCallback((arrayHelpers, files) => {
    const items = values.files ?? [];
    const names = items.map(item => item.file.name);

    try {
      isValidFile(files);
      isValidFileType(files);
      isValidFileName(values.files, files);

      Array.from(files)
        .filter(file => !names.includes(file.name))
        .map(file => ({file, type: '', id: id()}))
        .forEach(item => arrayHelpers.push(item))
    } catch (e) {
      toastHelper.error(e.message);
    } finally {
      inputRef.current.value = null;
    }
  }, [setFieldValue, values.files]);


  return { onUploadFiles, inputRef }
}

const isValidFile = (file) => {
  if (!file) {
    throw Error('Debe seleccionar un documento.');
  }

  return true;
};

const isValidFileType = (files) => {
  if (Array.from(files).some(file => file.type !== 'application/pdf')) {
    throw Error('Solo se permite adjuntar ficheros pdf.');
  }

  return true;
};

const isValidFileName = (existingDocuments, files) => {
  const fileNames = Array.from(files).map(file => file.name);
  if (existingDocuments?.some(doc => fileNames.includes(doc.file.name))) {
    throw Error('No se permiten documentos con el mismo nombre.');
  }

  return true;
};
